// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__3feG0","error":"card_error__1Zr7B"};